import React from 'react'
import styles from './Faculty.module.css'
import Navbar from './Navbar'
import Pets from '@material-ui/icons/Pets';
import Api from '../services/Api'
import Shared from '../services/Shared'

export default function Faculty() {

    const [faculty, setFaculty] = React.useState([]);

    React.useEffect(() => {

        Api.getFaculty( response =>{
            setFaculty(response);
        });
    }, [])

    return (
        <>
        <Navbar></Navbar>
        <div className={styles.contain}>
            <h1>Faculty &nbsp; <Pets/> </h1>
            <div className={styles.meet}>Meet our staff</div>
            <div className={styles.cards}>

                {faculty?.map(member => {
                    return (
                        <div className={styles.card} key={member.id}>
                            <div className={styles.cardDiv}>
                                <img className={styles.img} alt='professor' src={`${Shared.assets}${member.src}`} />
                                <div className={styles.bio}>
                                    <div className={styles.professor}>{member.name}</div>
                                    <div className={styles.facts}>
                                        <div>Favorite food: {member.favFood}</div>
                                        <div>Favorite celebrity: {member.favCelebrity}</div>
                                    </div>
                                    <div>{member.bio}</div>
                                </div>
                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
        </>
    )
}
